// The app environment is selected via Vite's --mode (import.meta.env.MODE); see the package.json scripts.
export type ENV = "localhost" | "production" | "test" | "dev" | "demo";

// Picks the entry matching the current Vite mode, throwing on an unknown/unmapped mode.
export const selectByMode = <T>(config: Record<ENV, T>): T => {
  const mode = import.meta.env.MODE as ENV;
  const selected = config[mode];
  if (!selected) {
    throw new Error(`Unknown mode "${mode}". Expected one of: ${Object.keys(config).join(", ")}.`);
  }
  return selected;
};
